import React from 'react';
import { Badge } from '@/components/ui/badge';
import { isLocalhost, isHomologation } from '@/lib/env';
import { cn } from '@/lib/utils';

export const EnvironmentFlag: React.FC = () => {
  // Se não for localhost nem homologação, não renderiza nada (Produção)
  if ( !isLocalhost && !isHomologation ) {
    return null;
  }

  const getEnvConfig = () => {
    if ( isLocalhost ) {
      return {
        label: 'LOCALHOST',
        className: 'bg-blue-500 hover:bg-blue-600 text-white border-none',
      };
    }
    if ( isHomologation ) {
      return {
        label: 'HOMOLOGAÇÃO',
        className: 'bg-orange-500 hover:bg-orange-600 text-white border-none',
      };
    }
    return {
      label: 'DESENVOLVIMENTO',
      className: 'bg-gray-500 hover:bg-gray-600 text-white border-none',
    };
  };

  const { label, className } = getEnvConfig();

  return (
    <div className="fixed bottom-4 left-4 z-[9999]">
      <Badge className={cn( "pointer-events-none px-3 py-1 text-[10px] font-bold shadow-lg animate-pulse", className )}>
        {label}
      </Badge>
    </div>
  );
};

export default EnvironmentFlag;
